import { render } from "./Providers.vue?vue&type=template&id=4071cd19&scoped=true"
import script from "./Providers.vue?vue&type=script&lang=js"
export * from "./Providers.vue?vue&type=script&lang=js"

import "./Providers.vue?vue&type=style&index=0&id=4071cd19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4071cd19"]])

export default __exports__